import classNames from 'clsx';
import React from 'react';

import type { LinkedImage } from '@swf/cms';
import { CMSImage, CMSLink } from '@swf/cms';
import useResolver from '@swf/core/hooks/useResolver';
import type { ClassNameProp } from '@swf/core/types/Props';

import styles from './CMSLinkedImage.scss';

const CMSLinkedImage: React.FC<LinkedImage & Partial<ClassNameProp>> = ({
  link,
  image,
  animated,
  className = ''
}) => {
  let url = useResolver(link.resolver_tag);
  if (!link.resolver_tag) {
    url = link.url || '';
  }

  return (
    <CMSLink {...{ ...link, url }} className={className}>
      <CMSImage
        {...image}
        className={classNames(className, { [styles.animateOnHover]: animated })}
      />
    </CMSLink>
  );
};

export default CMSLinkedImage;
